module.exports = __webpack_public_path__ + "static/media/GoogleCloud.72e96c36.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/powered/GoogleCloud.png
// module id = 96
// module chunks = 0